import React from 'react'

export type FareScrollStripCircleArrowProps = React.SVGProps<SVGSVGElement> & {
    rotationDeg?: number
}

export const FareScrollStripCircleArrow: React.FC<FareScrollStripCircleArrowProps> = ({
    rotationDeg = 0,
    className,
    style,
    ...rest
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="none"
        className={className}
        style={{
            display: 'block',
            transform: `rotate(${rotationDeg}deg)`,
            transformOrigin: 'center',
            ...style
        }}
        aria-hidden
        {...rest}
    >
        <path
            d="M19.775 26.95C19.9208 27.1056 20.1031 27.1736 20.3219 27.1542C20.5406 27.1347 20.7278 27.0472 20.8833 26.8917C21.0389 26.7361 21.1167 26.5481 21.1167 26.3278C21.1167 26.1074 21.0389 25.9259 20.8833 25.7833L16.1583 21.1167H27.3583C27.5528 21.1167 27.7278 21.0382 27.8833 20.8813C28.0389 20.7244 28.1167 20.5299 28.1167 20.298C28.1167 20.066 28.0384 19.8722 27.8819 19.7167C27.7253 19.5611 27.5314 19.4833 27.3 19.4833H16.1583L20.8833 14.7583C21.0389 14.6125 21.1069 14.4302 21.0875 14.2115C21.0681 13.9927 20.9806 13.8056 20.825 13.65C20.6694 13.4944 20.4815 13.4167 20.2611 13.4167C20.0407 13.4167 19.8593 13.4944 19.7167 13.65L14.35 19.075C14 19.425 13.825 19.8333 13.825 20.3C13.825 20.7667 14 21.175 14.35 21.525L19.775 26.95ZM20.3102 40.6C17.5034 40.6 14.8641 40.0674 12.3924 39.0022C9.92071 37.9369 7.77064 36.4913 5.94224 34.6652C4.11388 32.8391 2.66642 30.6918 1.59985 28.2232C0.533283 25.7546 0 23.1169 0 20.3102C0 17.5034 0.532603 14.8641 1.59781 12.3924C2.66305 9.92071 4.10871 7.77066 5.93477 5.9423C7.76088 4.1139 9.90823 2.66642 12.3768 1.59985C14.8454 0.533283 17.4831 0 20.2899 0C23.0966 0 25.7358 0.532603 28.2076 1.59781C30.6793 2.66305 32.8293 4.10871 34.6577 5.93478C36.4861 7.76088 37.9336 9.90823 39.0001 12.3768C40.0667 14.8454 40.6 17.4831 40.6 20.2899C40.6 23.0966 40.0674 25.7358 39.0022 28.2076C37.9369 30.6793 36.4913 32.8294 34.6652 34.6578C32.8391 36.4861 30.6918 37.9336 28.2232 39.0001 25.7546 40.0667 23.1169 40.6 20.3102 40.6ZM20.3 38.9667C25.4722 38.9667 29.8764 37.1486 33.5125 33.5125C37.1486 29.8764 38.9667 25.4722 38.9667 20.3C38.9667 15.1278 37.1486 10.7236 33.5125 7.0875C29.8764 3.45139 25.4722 1.63333 20.3 1.63333C15.1278 1.63333 10.7236 3.45139 7.0875 7.0875C3.45139 10.7236 1.63333 15.1278 1.63333 20.3C1.63333 25.4722 3.45139 29.8764 7.0875 33.5125C10.7236 37.1486 15.1278 38.9667 20.3 38.9667Z"
            fill="#1A1A1A"
        />
    </svg>
)
